import React from 'react';


export default () => (
  <div style={{ width: '60%', margin: 'auto', textAlign: 'center' }}>
    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        <h1 style={{ fontSize: 54 }}>
          403 Forbidden Access
        </h1>
        <iframe src="https://giphy.com/embed/Xb7VXx9yEzvtlFEM71" width="480" height="400" frameBorder="0" className="giphy-embed" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/CBSAllAccess-season-2-i-love-lucy-episode-28-Xb7VXx9yEzvtlFEM71">via GIPHY</a></p>
        <p style={{ fontSize: 24 }}>
          You need to be authenticated to access this content
        </p>
        <p style={{ fontSize: 24 }}></p>
    </div>
  </div>
);
